import { SignInPage, type IdentityProviders } from '@backstage/core-components';
import {
  configApiRef,
  microsoftAuthApiRef,
  type ConfigApi,
  type SignInPageProps,
  useApi,
} from '@backstage/core-plugin-api';
import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { scaffolderOwnerPickerModule } from './modules/scaffolder-owner-picker';
import { scaffolderAppNamePickerModule } from './modules/scaffolder-app-name-picker';
import { entityExpiryCardModule } from './modules/entity-expiry-card';

export const getSignInProviders = (config: ConfigApi): IdentityProviders => {
  const microsoftProvider = {
    id: 'microsoft-auth-provider',
    title: 'Microsoft',
    message: 'Sign in using Microsoft',
    apiRef: microsoftAuthApiRef,
  };

  if (config.getOptionalString('auth.environment') === 'production') {
    return [microsoftProvider];
  }

  const providers: IdentityProviders = ['guest'];

  if (config.has('auth.providers.microsoft')) {
    providers.push(microsoftProvider);
  }

  return providers;
};

const LocalSignInPage = (props: SignInPageProps) => {
  const config = useApi(configApiRef);

  return <SignInPage {...props} providers={getSignInProviders(config)} />;
};

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => LocalSignInPage,
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    scaffolderOwnerPickerModule,
    scaffolderAppNamePickerModule,
    entityExpiryCardModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
